module.exports = __webpack_public_path__ + "img/layout_top_tree_right.78b0b9ad.svg";